import { ApiRetailerPaymentType } from '@vend/types'
import { trackError } from '@vend/utilities'
import { PAYMENT_TYPES } from '@vend/business-components'
import { env } from '../../../../../../lib/env'

/**
 * Preload the signature image
 * Because the receipt template can not load the image by html, so preload the image.
 *
 * @param {string|null} imageSrc
 *        The signature image URL.
 *
 *  @return {Promise<string|null>} Resolved once the signature has been loaded.
 */
export const preloadSignatureImage = (
  imageSrc?: string
): Promise<string | null> => {
  return new Promise<string | null>(resolve => {
    const signature = new Image()
    signature.addEventListener('error', () => resolve(null))

    try {
      // Validate the text passed is a url to avoid XSS
      const url = new URL(imageSrc || '').toString()
      signature.addEventListener('load', () => resolve(url))
      signature.src = url
    } catch (error) {
      trackError('[GatewayHandler] Received an invalid signature image url.', {
        error,
        imageSrc,
      })
      resolve(null)
    }
  })
}

/**
 * Gets the base payment portal url from a retailer payment type.
 *
 * @param paymentType - The retailer payment type to get the base payment portal url from.
 * @returns - The base payment portal url. Will be an empty string if no payment portal url could be found.
 */
export const getBasePaymentPortalUrl = (
  paymentType: ApiRetailerPaymentType
): string => {
  let basePaymentPortalUrl = paymentType.config?.url
    ? paymentType.config.url
    : ''

  if (paymentType.type_id === PAYMENT_TYPES.TYRO) {
    const gatewayEnv = env.isProduction() ? '' : 'test.'
    basePaymentPortalUrl = `https://iclient.${gatewayEnv}tyro.com/vend.html#`
  }

  return basePaymentPortalUrl
}
